import { html, nothing } from 'lit';
import { featuresTypes } from '../../defs/featureTypes';
import { localDate, localTime } from './util';
import comsStore from '../../state/ComsStore';
const labelTmpl = (granted) => {
    const status = granted ? 'approved' : 'rejected';
    const text = granted ? 'Zustimmung' : 'Widerspruch';
    return html `
    <span class="history-status history-status--${status}">
      ${text}
    </span>
  `;
};
const featureTmpl = (feature) => html `
  <div class="row">
    <div class="col">${feature.title}</div>
    <div class="col">${labelTmpl(!!feature.granted)}</div>
  </div>
`;
const predeseccorsTemplate = (predecessors) => {
    if (!predecessors) {
        return nothing;
    }
    return html `
    <div>
        Vorgänger: ${predecessors.map(({ id, name }, ind) => html `
          ${ind > 0 ? ' und ' : nothing}
          <a
            role="button"
            @click=${() => {
        comsStore.history.configId = id;
    } /* eslint-enable @typescript-eslint/indent */}
          >
            ${name}
          </a>
        `)}
    </div>
  `;
};
const historyConsentItem = (coms) => {
    const existingFeatureName = featuresTypes.find((fn) => !!coms[fn]);
    const feats = existingFeatureName ? coms[existingFeatureName] : [];
    return html `
      ${labelTmpl(coms.granted)}
      <div>${feats.map(featureTmpl)}</div>
      <span class="history-changed">
         <tef-coms-icon icon="clock" context="selfcare selfcare" size="m" type="default"></tef-coms-icon>
         Geändert von Agent: ${coms.meta.username} über ${coms.meta.channelDisplay};  Version ${coms.version}
         ${predeseccorsTemplate(coms.meta.predecessors)}
      </span>
  `;
};
export const historyItemTemplate = (item) => html `
  <div class="history-entry">
    <p>
      <span class="history-timestamp">
        ${localDate(item.actionDate)} ${localTime(item.actionDate)}
      </span>
    </p>
    ${item.consents.map(historyConsentItem)}
  </div>
`;
//# sourceMappingURL=historyItem.tmpl.js.map